import { render, staticRenderFns } from "./OntologyDistance.vue?vue&type=template&id=4171c82b&lang=pug&"
import script from "./OntologyDistance.vue?vue&type=script&lang=js&"
export * from "./OntologyDistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports